// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3uJQ_","toggle":"styles_toggle__3ad9R","preview":"styles_preview__2ub-n"};